var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCandle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00a4c7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.64,30.49c-3.63-5.66,1.79-12.57,1.79-12.57,5.79,9.21,2.03,12.57,2.03,12.57,8.22-3.68,7.44-10.68,3.06-17.4C24.55,5.46,30.89,0,30.89,0c-5.11.56-11.51,6.8-13.71,16.8-2.28,10.42,5.45,13.68,5.45,13.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.34,69.98v-34.67c0-1.3-1.19-2.26-2.45-1.98l-7.07,1.62v-5.74c0-.52-.42-.94-.93-.94h-.55c-.51,0-.93.42-.93.94v6.29l-8.03,1.84c-.91.21-1.56,1.03-1.56,1.98v30.65H0c.05.1.11.19.16.29,2.47,4.2,7,6.74,11.83,6.74h24c4.84,0,9.37-2.53,11.83-6.74.06-.09.11-.19.16-.29h-12.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCandle);
export default __webpack_public_path__ + "static/media/Icon-Candle.93421c552c37f0f3f6ad3701c129ae6c.svg";
export { ForwardRef as ReactComponent };